import React, { useState, useContext } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import AuthContext from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ChangePasswordPage = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { user, logout, changePassword } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (password !== confirmPassword) {
            setError('비밀번호가 일치하지 않습니다.');
            return;
        }

        try {
            await changePassword(currentPassword, password);
            setSuccess('비밀번호가 성공적으로 변경되었습니다. 3초 후 자동으로 로그아웃되며, 다시 로그인해주세요.');
            setTimeout(() => {
                logout();
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.message);
            console.error(err);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <div style={{ width: '100%', maxWidth: '500px' }}>
                <Card>
                    <Card.Body className="p-4">
                        <h3 className="text-center mb-4">비밀번호 변경</h3>
                        <p className="text-center text-muted">안녕하세요, {user?.username}님. 새로운 비밀번호를 입력해주세요.</p>
                        <Form onSubmit={handleSubmit}>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}
                            <Form.Group className="mb-3" controlId="currentPassword">
                                <Form.Label>현재 비밀번호</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="password">
                                <Form.Label>새 비밀번호</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <Form.Text className="text-muted">
                                    비밀번호는 6자 이상이어야 합니다.
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="confirmPassword">
                                <Form.Label>새 비밀번호 확인</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <div className="d-grid">
                                <Button variant="primary" type="submit" disabled={!!success}>
                                    비밀번호 변경
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default ChangePasswordPage;
